export const frontmatter = {
    "draft": true,
    "title": "Grupos de atención",
    "sidebar_group": "referencia",
    "sidebar_label": "Grupos de atención",
    "sidebar_order": 8
}

export const toc = []